import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-self: flex-start;
  flex-direction: column;
  margin-bottom: 20px;
`;
